"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFailed = exports.uploadCompleted = exports.beginUpload = void 0;
const immer_1 = require("immer");
const BEGIN_UPLOAD = "uploads.begin_upload";
const UPLOAD_COMPLETED = "uploads.upload_completed";
const UPLOAD_FAILED = "uploads.upload_failed";
function beginUpload(upload) {
    return {
        type: BEGIN_UPLOAD,
        upload,
    };
}
exports.beginUpload = beginUpload;
function uploadCompleted(key) {
    return {
        type: UPLOAD_COMPLETED,
        key,
    };
}
exports.uploadCompleted = uploadCompleted;
function uploadFailed(key) {
    return {
        type: UPLOAD_FAILED,
        key,
    };
}
exports.uploadFailed = uploadFailed;
const uploadReducer = (0, immer_1.produce)((draft, action) => {
    if (draft === undefined) {
        return [];
    }
    switch (action.type) {
        case BEGIN_UPLOAD:
            draft.push(Object.assign(Object.assign({}, action.upload), { status: "IN_PROGRESS" }));
            break;
        case UPLOAD_COMPLETED:
            for (let upload of draft) {
                if (upload.key === action.key) {
                    upload.status = "COMPLETED";
                }
            }
            break;
        case UPLOAD_FAILED:
            for (let upload of draft) {
                if (upload.key === action.key) {
                    upload.status = "FAILED";
                }
            }
            break;
    }
});
exports.default = uploadReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBsb2Fkc1JlZHVjZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9wcm9qZWN0L3VwbG9hZHNSZWR1Y2VyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpQ0FBZ0M7QUFVaEMsTUFBTSxZQUFZLEdBQUcsc0JBQXNCLENBQUM7QUFDNUMsTUFBTSxnQkFBZ0IsR0FBRywwQkFBMEIsQ0FBQztBQUNwRCxNQUFNLGFBQWEsR0FBRyx1QkFBdUIsQ0FBQztBQUU5QyxTQUFnQixXQUFXLENBQUMsTUFBdUM7SUFDakUsT0FBTztRQUNMLElBQUksRUFBRSxZQUFZO1FBQ2xCLE1BQU07S0FDUCxDQUFDO0FBQ0osQ0FBQztBQUxELGtDQUtDO0FBRUQsU0FBZ0IsZUFBZSxDQUFDLEdBQVc7SUFDekMsT0FBTztRQUNMLElBQUksRUFBRSxnQkFBZ0I7UUFDdEIsR0FBRztLQUNKLENBQUM7QUFDSixDQUFDO0FBTEQsMENBS0M7QUFFRCxTQUFnQixZQUFZLENBQUMsR0FBVztJQUN0QyxPQUFPO1FBQ0wsSUFBSSxFQUFFLGFBQWE7UUFDbkIsR0FBRztLQUNKLENBQUM7QUFDSixDQUFDO0FBTEQsb0NBS0M7QUFFRCxNQUFNLGFBQWEsR0FBRyxJQUFBLGVBQU8sRUFDM0IsQ0FBQyxLQUFtQixFQUFFLE1BQU0sRUFBZ0IsRUFBRTtJQUM1QyxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDdkIsT0FBTyxFQUFFLENBQUM7S0FDWDtJQUNELFFBQVEsTUFBTSxDQUFDLElBQUksRUFBRTtRQUNuQixLQUFLLFlBQVk7WUFDZixLQUFLLENBQUMsSUFBSSxpQ0FDTCxNQUFNLENBQUMsTUFBTSxLQUNoQixNQUFNLEVBQUUsYUFBYSxJQUNyQixDQUFDO1lBQ0gsTUFBTTtRQUNSLEtBQUssZ0JBQWdCO1lBQ25CLEtBQUssSUFBSSxNQUFNLElBQUksS0FBSyxFQUFFO2dCQUN4QixJQUFJLE1BQU0sQ0FBQyxHQUFHLEtBQUssTUFBTSxDQUFDLEdBQUcsRUFBRTtvQkFDN0IsTUFBTSxDQUFDLE1BQU0sR0FBRyxXQUFXLENBQUM7aUJBQzdCO2FBQ0Y7WUFDRCxNQUFNO1FBQ1IsS0FBSyxhQUFhO1lBQ2hCLEtBQUssSUFBSSxNQUFNLElBQUksS0FBSyxFQUFFO2dCQUN4QixJQUFJLE1BQU0sQ0FBQyxHQUFHLEtBQUssTUFBTSxDQUFDLEdBQUcsRUFBRTtvQkFDN0IsTUFBTSxDQUFDLE1BQU0sR0FBRyxRQUFRLENBQUM7aUJBQzFCO2FBQ0Y7WUFDRCxNQUFNO0tBQ1Q7QUFDSCxDQUFDLENBQ0YsQ0FBQztBQUNGLGtCQUFlLGFBQWEsQ0FBQyJ9